import { ContentTypeOptions } from '../enums/FilterOptions';
import { z } from 'zod';

export const PremiumContentListDto = z
  .object({
    search: z.string().trim().max(255).optional(),
    contentType: z.array(z.nativeEnum(ContentTypeOptions)).optional(),
    favoritesOnly: z.boolean().optional(),
    // Narrows the catalog to the row that registers this one content item —
    // how a content preview finds the premium id it favorites.
    contentId: z.string().uuid().optional(),
    // QueryAllDto convention: offset is a 1-based page
    offset: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(25),
    orderBy: z.enum(['createdAt']).optional(),
    orderDirection: z.string().min(1).max(4).optional(),
  })
  .strict();

export type ApiPremiumContentListDto = z.infer<typeof PremiumContentListDto>;

export const PremiumContentSetItemDto = z
  .object({
    enabled: z.boolean(),
  })
  .strict();

export type ApiPremiumContentSetItemDto = z.infer<
  typeof PremiumContentSetItemDto
>;
